import { memo, type ReactNode } from 'react';
import { Link } from '~/components/ui/Link';
import { TextShimmer } from '~/components/ui/TextShimmer';

export const LoadingScreen = memo(() => {
  return (
    <div className="flex flex-col size-full items-center select-text selection-accent">
      <div className="flex-1 flex flex-col items-center justify-center gap-6 opacity-40">
        <div className="i-bolt:logos-bolt-b size-16 text-gray-400 dark:text-gray-600" />
        <TextShimmer
          className="[--base-color:var(--bolt-elements-textTertiary)] dark:[--base-color:var(--bolt-elements-textSecondary)] [--base-gradient-color:var(--bolt-elements-textPrimary)]"
          duration={1.5}
          spread={2}
          length={120}
        >
          Your preview will appear here
        </TextShimmer>
      </div>
      <div className="flex gap-5 mb-5">
        <HelpLink href="https://support.bolt.new">
          <div className="i-ph:question text-lg" />
          Help Center
        </HelpLink>
        <HelpLink href="https://discord.com/invite/stackblitz">
          <div className="i-bolt:logos-discord?mask text-lg" />
          Join our Community
        </HelpLink>
      </div>
    </div>
  );
});

interface HelpLinkProps {
  href: string;
  children: ReactNode;
}

const HelpLink = memo<HelpLinkProps>(({ href, children }) => {
  return (
    <Link className="flex gap-1 items-center no-underline text-sm" href={href} target="_blank">
      {children}
    </Link>
  );
});
